const BACKEND_URL_MAP: any = {
  dev: 'http://localhost:5002',
  staging: 'https://coelab-service.herokuapp.com',
  prod: 'https://coelab-server-prod.herokuapp.com',
};

export const { REACT_APP_BUILD_ENV } = process.env;

export const BACKEND_URL = REACT_APP_BUILD_ENV ? BACKEND_URL_MAP[REACT_APP_BUILD_ENV] : BACKEND_URL_MAP['staging'];

const CHAT_UI_URL_MAP: any = {
  dev: 'https://staging.d1e1vtl7mhq92w.amplifyapp.com',
  staging: 'https://staging.d1e1vtl7mhq92w.amplifyapp.com',
  prod: 'https://main.d1e1vtl7mhq92w.amplifyapp.com',
};

export const CHAT_UI_URL = REACT_APP_BUILD_ENV ? CHAT_UI_URL_MAP[REACT_APP_BUILD_ENV] : CHAT_UI_URL_MAP['dev'];
